module.exports = __webpack_public_path__ + "img/faq_ellipse.96decc79.webp";